// Common date formatting utility for DD/MM/YY format
export const formatDateDDMMYY = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';
  
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  }).format(date);
};

// Alternative function for cases where empty string is preferred over '-'
export const formatDateDDMMYYEmpty = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  }).format(date);
};

// Financial Year options (1 April to 31 March)
export const FINANCIAL_YEAR_OPTIONS = [
  { id: '2024–25', name: '2024–25', value: '2024–25' },
  { id: '2025–26', name: '2025–26', value: '2025–26' },
  { id: '2026–27', name: '2026–27', value: '2026–27' },
  { id: '2027–28', name: '2027–28', value: '2027–28' },
  { id: '2028–29', name: '2028–29', value: '2028–29' },
  { id: '2029–30', name: '2029–30', value: '2029–30' },
  { id: '2030–31', name: '2030–31', value: '2030–31' },
  { id: '2031–32', name: '2031–32', value: '2031–32' },
  { id: '2032–33', name: '2032–33', value: '2032–33' },
  { id: '2033–34', name: '2033–34', value: '2033–34' },
  { id: '2034–35', name: '2034–35', value: '2034–35' },
  { id: '2035–36', name: '2035–36', value: '2035–36' },
  { id: '2036–37', name: '2036–37', value: '2036–37' },
  { id: '2037–38', name: '2037–38', value: '2037–38' },
  { id: '2038–39', name: '2038–39', value: '2038–39' },
  { id: '2039–40', name: '2039–40', value: '2039–40' },
  { id: '2040–41', name: '2040–41', value: '2040–41' },
]; 